// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wZjR","placeholdersHeader":"styles_placeholdersHeader__QlYGp","editorStyle":"styles_editorStyle__sAG6H","placeholdersBox":"styles_placeholdersBox__22u-0"};